module.exports = __webpack_public_path__ + "static/media/star-of-life.5c93a97a.svg";